import { NAV_LINKS, ZONE_LINKS, SIDE_TOPICS } from "../../../mocks/chigua";

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      {/* CTA 带 */}
      <div className="border-b border-background-50/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-accent-300">
              <i className="ri-video-chat-line animate-cg-blink" /> 今晚 20:00 现场加更
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-background-50 leading-tight">
              蹲了一天的神评论，<br className="hidden md:block" />
              别错过今晚的反转现场
            </h2>
            <p className="mt-3 text-sm text-background-100/70 leading-relaxed">
              新一集高能回复已经攒满讨论广场，围观群众就差你了。理性吃瓜，按时补觉。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="#hero"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-accent-500 hover:bg-accent-400 text-foreground-950 px-6 py-3 text-sm font-semibold transition-colors whitespace-nowrap"
            >
              <i className="ri-time-line" /> 预约今晚提醒
            </a>
            <a
              href="#scene"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/25 hover:border-accent-400 hover:text-accent-300 px-6 py-3 text-sm text-background-100 transition-colors whitespace-nowrap"
            >
              先回今日封面 <i className="ri-arrow-right-s-line" />
            </a>
          </div>
        </div>
      </div>

      {/* 主体 */}
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-8">
        <div className="col-span-2 lg:col-span-4">
          <div className="flex items-center gap-3">
            <span className="grid h-10 w-10 place-items-center rounded-sm bg-background-50 text-primary-700">
              <i className="ri-eye-2-line text-xl" />
            </span>
            <div>
              <p className="font-heading text-lg font-black text-background-50 leading-none">抓奸实录</p>
              <p className="mt-1 text-[11px] tracking-[0.22em] text-accent-300">网友热议 · 神评论聚集地</p>
            </div>
          </div>
          <p className="mt-5 text-sm text-background-100/70 leading-relaxed max-w-sm">
            抓奸实录聚合全网吃瓜现场与评论区高能瞬间，带你围观网友热议、解锁抓奸实录神评论。理性围观、人物打码、剧情虚构，是本站不变的底色。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-weibo-line", "ri-douban-line", "ri-bilibili-line", "ri-reddit-line"].map((ic) => (
              <a
                key={ic}
                href="#hero"
                aria-label="社交平台"
                className="grid h-9 w-9 place-items-center rounded-full border border-background-50/20 text-background-100/80 hover:border-accent-400 hover:text-accent-300 transition-colors"
              >
                <i className={ic} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">栏目直达</h4>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.key}>
                <a href={`#${l.key}`} className="text-sm text-background-100/70 hover:text-accent-300 transition-colors">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">现场分区</h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
            {ZONE_LINKS.map((z) => (
              <li key={z.name}>
                <a href="#scene" className="text-sm text-background-100/70 hover:text-accent-300 transition-colors whitespace-nowrap">
                  {z.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-2 md:col-span-1 lg:col-span-3">
          <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">围观热词</h4>
          <div className="flex flex-wrap gap-2">
            {SIDE_TOPICS.slice(0, 4).map((t) => (
              <a
                key={t.name}
                href="#rank"
                className="inline-flex items-center gap-1 rounded-full bg-background-50/10 px-3 py-1.5 text-xs text-background-100/80 hover:bg-accent-500 hover:text-foreground-950 transition-colors whitespace-nowrap"
              >
                {t.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* 免责 + 版权 */}
      <div className="border-t border-background-50/10">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60 text-center sm:text-left leading-relaxed">
            本站内容为虚构娱乐演示，人物均打码处理，不代表任何真实事件与当事人观点。请理性围观、拒绝网暴。
          </p>
          <p className="text-xs text-background-100/60 flex items-center gap-3 whitespace-nowrap">
            <span>© 2026 抓奸实录</span>
            <span className="inline-flex items-center gap-1">
              <i className="ri-copyright-line" /> 吃瓜现场
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}